import React from 'react';

export class AdvanceSearchForm extends React.Component {
    constructor(props) {
        super(props);
        this.handleSearch = this.handleSearch.bind(this);
    }

    handleSearch = (event) => {
        const value = event.target.value;
        this.props.onChildKeyUp(value);
    }
    render() {
        let page = this.props.page;
        
        return (
            <form className="form search-form" id={"search-form-"+page}>
                <input
                type="text"
                value={this.props.value}
                className="input"
                id={"search-"+page}
                placeholder={"search "+page+" results"}
                onKeyUp={() => this.handleSearch}
                onChange={(e) => this.props.onChildKeyUp(e.target.value)}
                onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault(); // also block enter
                }
                }}
                />
            </form>
        )
    }
}